import { useEffect, useState } from "react";
import axios from "axios";
import { IListResponse, IResponse } from "../types/api";
import { SelectItem } from "@mantine/core";

interface ICategory {
    categoryNumber: number;
    title: string;
}

export const useCategoryNumber = () => {

    const [ categories, setCategories ] = useState<SelectItem[]>([]);
    useEffect(() => {
        const fetchData = async () => {
            const { data } = await axios.get<IListResponse<ICategory>>('/api/category?page=1&limit=200');
            setCategories((data.result.docs ?? []).map((item) => {
                return {
                    label: item.title,
                    value: item.categoryNumber.toString()
                }
            }))
        }
        void fetchData();
    }, []);

    return categories;
}